<script setup lang="ts">
import GaiaText from './GaiaText.vue';
import { gaiaTracking } from '../themes/tokens';
</script>

<template>
  <!-- The muted uppercase count beside a page title ("6 views") from the CM
       mocks — same idiom as GaiaSectionHeader's count, standalone. -->
  <gaia-text
    class="gaia-count-label"
    variant="label"
    size="control"
    weight="semibold"
    tone="muted"
    :style="{ letterSpacing: gaiaTracking.labelSoft }"
  >
    <slot />
  </gaia-text>
</template>
